import React from 'react'
import { formatDate, formatMoney } from '@ztechapps/common.utils'
import { ShowIf } from '@ztechapps/webui.util'

export const RateCard = ({
  item,
  amount,
  description = 'as your shipping amount',
  onSelect,
  onChange,
  active,
}: {
  item
  amount: number
  description?: string
  onSelect?: any
  onChange?: any
  active: boolean
}) => {
  onSelect =
    onSelect ??
    ((e) => {
      e?.preventDefault()
      onChange({ carrierRate: item, shippingFee: item.shippingAmount, isManualShippingRate: false, hasSelected: true })
    })

  return (
    <div onClick={onSelect} className={`card  ${active ? 'bg-primary' : ''} `}>
      <div className="card-header">
        <div className="font-weight-bold">
          {formatMoney(amount)} <small className="text-black-50"> - {description}</small>{' '}
        </div>
      </div>
      <div className={`card-body ${active ? 'text-white' : 'text-black-50'}`}>
        <div className="d-flex justify-content-between">
          <div>Courier</div>
          <div className="text-end">
            {item?.serviceType} - {item?.carrierName}
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div>Est. Arrival:</div>
          <div className="text-end">
            {formatDate(item?.estimatedDeliveryDate)} <br />
            <ShowIf condition={!!item?.deliveryDays}>
              <small>within {item?.deliveryDays} days</small>
            </ShowIf>
          </div>
        </div>
      </div>
    </div>
  )
}
